(function () {
    'use strict';

    angular.module('conferencesApp').filter('ucfirst', function () {
        return function(input) {
            return angular.isString(input) ? input.charAt(0).toUpperCase() + input.substring(1) : input;
        };
    });
})();
